import React,{useState,useEffect} from "react";


import { useDispatch } from "react-redux";
const RangeSliderBasic = ({setSliderVal,sliderVal,rangeIntervalType, rangeStart,rangeEnd ,pxPerType  }) => {
  
  
    
       const dispatch = useDispatch();  
     const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
            {
              
              dispatch({type: "CURSOR",payload:true  });
          
              dispatch({type: "CURSORTEXT",payload:CursorText})
              dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
              dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
            }
             
            const handleMouseLeave = () => {
              
              dispatch({type: "CURSOR",payload:false})
          
              dispatch({type: "CURSORTEXT",payload:""})
          
              dispatch({type: "CURSORTEXTBG",payload:""})
              dispatch({type: "CURSORTEXTCOLOR",payload:""})
            
          
          }
            
       
  
  const [value, setValue] = useState();
     useEffect(()=>{
      setValue(sliderVal?sliderVal:10)
     },[])
      let intervals=[1,100]
    if(rangeIntervalType=="fontsize"){
        intervals =[8,16, 22, 28, 32 , 38 ];
    }
     if(rangeIntervalType=="textMargin"){
        intervals =[1,10, 20, 30, 40 , 50 ];
    } if(rangeIntervalType=="itemMargin"){
        intervals =[0, 20, 40, 60 ,80, 100 ];
    }else{
       intervals =[0,2,4,6,8,10];
    }
    
    return (
      <div className="range-slider-basic">
        <input
          type="range"
          min={rangeStart}
          max={rangeEnd}
          value={value}
          onChange={(e) => {setValue(parseInt(e.target.value)) ;setSliderVal(parseInt(e.target.value))}}
          className="slider-basic"
        />
        <div className="marks"> 
        {intervals?.map((mark,index) => (
          <span  onClick={() => {setValue(mark) ;setSliderVal(mark);;}}  onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave} 
            key={mark}
            className={`mark-basic ${value === mark ? '' : ''}`}
            style={{ left: `${index*20}%` }}
          >
            {mark}
          </span>
        ))}
      </div>{/* Marker that moves with thumb */}
  <div
    className={`mark-floating ${value ? 'active-basic' : ''}`}
    style={{
      left: `${((value - 6) / (rangeEnd - 6)) * 100}%`,
    }}
  >
    {value}{pxPerType}
  </div>
          </div>
    );
  };
  export default RangeSliderBasic;